import { RadioOption } from "./index";
import { SvgIconType } from "@/svg";

export type RadioGroupOption<T extends string> = {
  value: T;
  label: string;
  icon: SvgIconType;
};

type RadioGroupProps<T extends string> = {
  options: RadioGroupOption<T>[];
  value: T;
  onChange: (value: T) => void;
  className?: string;
};

export function RadioGroup<T extends string>({
  options,
  value,
  onChange,
  className = "",
}: RadioGroupProps<T>) {
  return (
    <div className={`space-y-2 ${className}`}>
      {options.map((option) => (
        <RadioOption
          key={option.value}
          value={option.value}
          selectedValue={value}
          icon={option.icon}
          label={option.label}
          onChange={onChange}
        />
      ))}
    </div>
  );
}
